import api from 'api';

import { ExchangeRatesResponse, type Partner } from './types';

export const getSearchSuggestionList = async (query: string) => {
  if (query.length < 3) {
    return [];
  }

  const { data } = await api.get(`/search/${query}`);

  return data;
};

/**
 * Get list of suggestions for cities
 *
 * @param query string possible city string
 * @returns SearchQueryResult
 */
export const getCityList = async (query: string | undefined) => {
  if (!query) {
    return [];
  }
  if (query.length < 3) {
    return [];
  }

  const { data } = await api.get(`/cities/search/${query}`);

  return data;
};

export const getPartners = async () => {
  const { data } = await api.get<Partner[]>(`/partners`);

  return data;
};

export const getExchangeRates = async () => {
  const { data } = await api.get<ExchangeRatesResponse>(
    `currencies/exchange-rates`
  );

  return data;
};
